import EmployeeSelect from '@/components/Form/Shared/EmployeeSelect'
import ProductGroupSelect from '@/components/Form/Shared/ProductGroupSelect'
import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormItem } from 'vnetwork-ui'
import { ServiceMonthlyReportFilters } from '../types'
import { DEPARTMENT_IDS } from '@/constants/departments'

interface FiltersProps {
    control: UseFormReturn<
        ServiceMonthlyReportFilters & { showComparison: boolean }
    >['control']
    setValue: UseFormReturn<
        ServiceMonthlyReportFilters & { showComparison: boolean }
    >['setValue']
    showComparison: boolean
}

const Filters: React.FC<FiltersProps> = ({ control, setValue }) => {
    const { t } = useTranslation()

    const currentYear = new Date().getFullYear()

    // Generate year options from 2020 to current year + 1
    const yearOptions = useMemo(() => {
        const years = []
        for (let year = currentYear + 1; year >= 2020; year--) {
            years.push({
                label: year.toString(),
                value: year,
            })
        }
        return years
    }, [currentYear])

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 p-4 bg-white rounded-md">
            <FormItem
                control={control}
                name="year"
                type="select"
                label={t('year')}
                options={yearOptions}
                allowClear={false}
            />

            <ProductGroupSelect
                control={control}
                name="product_group_name"
                showLabel
                multiple
            />
            <EmployeeSelect
                control={control}
                multiple
                onlyActive
                departmentIds={[DEPARTMENT_IDS.ACCOUNT]}
                name="account_manager_codes"
                label="account_manager_codes"
                showLabel
            />
            <EmployeeSelect
                control={control}
                multiple
                onlyActive
                departmentIds={[
                    DEPARTMENT_IDS.SALES,
                    DEPARTMENT_IDS.ACCOUNT,
                    DEPARTMENT_IDS.BOARD_OF_DIRECTORS,
                ]}
                name="sale_manager_codes"
                label="sale_manager_codes"
                showLabel
            />
            <FormItem
                control={control}
                name="showComparison"
                type="checkbox"
                label={t('compare_with_previous_year')}
                onChangeAfterHookForm={(value) =>
                    setValue('showComparison', value)
                }
            />
        </div>
    )
}

export default Filters
